







import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, Watch} from "vue-property-decorator";

@Component
export default class Message extends Vue {
    /**
     * Controla la visibilidad del mensaje
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Duración del mensaje en milisegundos
     */
    @Prop({type: Number, default: 5000})
    public duration: number

    public display = false

    @Watch('value')
    watchValue (value: boolean) {
        this.display = value
        if (!this.display) {
            return
        }

        setTimeout(() => this.display = false, this.duration)
    }

}
